<template>
	<router-view id="app"/>
</template>

<script>
import skrollr from 'skrollr'
import { smoothScroll } from '@/lib/utils'

export default {
	data: () => ({
		s: null,
	}),
	created() {
	},
	mounted() {
		smoothScroll(this.$el)
		this.$nextTick(() => {
			setTimeout(() => {
				this.s = skrollr.init()
				if (window.innerWidth < 800) {
					this.s.destroy()
				}
			}, 1000)
		})
	},
	metaInfo: () => ({
		title: 'Virtual Event Design',
		titleTemplate: '%s | Genesis Exhibits',
		meta: [
				{
					charset: 'utf-8',
				},
				{
					'http-equiv': 'X-UA-Compatible',
					content: 'IE-edge',
				},
				{
					name: 'description',
					content: '',
				},
				{
					name: 'viewport',
					content: 'width=device-width, initial-scale=1, maximum-scale=5',
				},
		],
		link: [
			{
				rel: 'stylesheet',
				href: '//fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,800;1,600&family=Material+Icons&display=swap',
			},
		],
		script: [
			// Analytics
			{
				// innerHTML: `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){ (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,'script','https://www.google-analytics.com/analytics.js','ga'); ga('create', 'UA-247865-6', 'auto'); ga('send', 'pageview');`,
				// type: `text/javascript`
			},
		],
		__dangerouslyDisableSanitizers: ['script'],
	}),
}
</script>

<style lang="scss">
body, html {
	background-color: black;
	margin: 0;
	padding: 0;
}
html {
	height: 100%;
	scroll-behavior: smooth;
}
body {
	height: 100%;
}

#app {
	background-color: black;
	height: 100%;
	font-family: "Open Sans", "Roboto", Arial, Helvetica, sans-serif;
	// overflow-x: hidden;
	position: relative;
}
</style>
